import { PostHogProvider as PHProvider } from "@posthog/react";
import React from "react";
import { isDemo, isLocalhost, isStaging } from "utils/axios-instance";

const isDebugEnv = isLocalhost || isStaging || isDemo;

// Same public project key as backend analytics.py
const posthogApiKey =
  process.env.REACT_APP_POSTHOG_PROJECT_TOKEN ??
  "phc_UTMIKTmL8Vu1ARhfW9Rnt0PLq2Bd1gXgXooAdhmgqoM";
const posthogHost =
  process.env.REACT_APP_POSTHOG_HOST ?? "https://us.i.posthog.com";

const posthogOptions = {
  api_host: posthogHost,
  defaults: "2026-01-30",
} as const;

type PostHogProviderProps = {
  children: React.ReactNode;
};

export function PostHogProvider({ children }: PostHogProviderProps) {
  if (isDebugEnv || !posthogApiKey) {
    return <>{children}</>;
  }

  return (
    <PHProvider apiKey={posthogApiKey} options={posthogOptions}>
      {children}
    </PHProvider>
  );
}
